import WithRender from "../../templates/layouts/layoutUploadPersonalizationFullPageConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getMatrixComplete",
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ])
  }
});
